const tinymcModel = { 
    apiKey:'1jqnur9qfu1rmlxphh56l3nr22s9fwmnsqitmsvod4smzbef',
    // apiKey:'1caoqocqc05l8re1m7vm2ck0f4lbaqvg7w9k6a7wr7pkrbhv',
    plugins:'lists formatselect',
    toolbar:'styles formatselect numlist bullist bold italic format alignment alignleft aligncenter alignright'
 }
export default tinymcModel